(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3813],{

/***/ 15510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores",
      function () {
        return __webpack_require__(83551);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_stores; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/meta/index.tsx + 2 modules
var meta = __webpack_require__(59409);
// EXTERNAL MODULE: ./src/components/store-selector/index.tsx
var store_selector = __webpack_require__(99258);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var utils = __webpack_require__(14250);
;// CONCATENATED MODULE: ./src/screens/stores/header/elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-bottom: ",
        "px;\n\n  p:last-child {\n    display: none;\n\n    ",
        " {\n      display: block;\n      margin-top: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var spacing = utils/* themeGetters.spacing */.$z.spacing;
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef04f98-0"
})(_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), spacing("compact"));

;// CONCATENATED MODULE: ./src/screens/stores/header/index.js




var Header = function(props) {
    var title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "p",
                $textStyle: "h4Semibold",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "p",
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/screens/stores/index.js






var StoresScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* DefaultLayout */.HQ, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {
                title: "Tiendas",
                subTitle: "Encuentra la tienda de tu preferencia",
                style: {
                    marginBottom: theme/* default.spacing.comfortable */.Z.spacing.comfortable
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(store_selector/* default */.Z, {
                onlyPickables: false
            })
        ]
    });
};
/* harmony default export */ var stores = (StoresScreen);

// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/utils/get-meta-info.ts
var get_meta_info = __webpack_require__(5024);
// EXTERNAL MODULE: ./src/utils/redirect-to.ts
var redirect_to = __webpack_require__(53337);
;// CONCATENATED MODULE: ./pages/stores.tsx









function StoresPage(props) {
    var metaInfo = props.metaInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaInfo), {
                title: "Tiendas"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stores, {})
        ]
    });
}
StoresPage.getInitialProps = function(context) {
    if (!context.hasFlag(constants/* flags.LIST_STORES */.id.LIST_STORES)) {
        return (0,redirect_to/* default */.Z)("/", context);
    }
    return {
        metaInfo: (0,get_meta_info/* default */.Z)(context)
    };
};
/* harmony default export */ var pages_stores = (StoresPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [157,3409,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(15510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);